import React, { useEffect, useState } from 'react'

import styled, { css } from 'styled-components'

const StyledTooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`

const StyledTooltipContent = styled.div`
  display: none;
  position: absolute;
  padding: 12px 16px;
  border-radius: 4px;
  box-shadow: 0 20px 40px 0 rgba(24, 27, 37, 0.16);
  border: solid 1px var(--Grey900);
  background-color: var(--Dove);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.8;
  color: var(--Text500);
  z-index: 1000;
  width: clamp(240px, 310px, 380px);
  text-align: center;

  ${({ placement, leftPosition }) => {
    switch (placement) {
      case 'top':
        return css`
          bottom: 125%;
          left: ${leftPosition};
          transform: translateX(-${leftPosition});
        `
      case 'right':
        return css`
          top: 50%;
          left: 108%; // Fixed position for right placement
          transform: translateY(-50%);
        `
      case 'left':
        return css`
          top: 50%;
          right: 108%; // Fixed position for left placement
          transform: translateY(-50%);
        `
      case 'bottom':
        return css`
          top: 100%;
          left: ${leftPosition+250};
          transform: translateX(-${leftPosition+250});
          
        `
      default:
        return css`
          top: 125%;
          left: ${leftPosition};
          transform: translateX(-${leftPosition});
        `
    }
  }}

  ${StyledTooltipContainer}:hover & {
    display: block;
  }
`

const MyTooltip = ({
  title,
  placement = 'bottom',
  arrow = false,
  children,
  containerWidth,
}) => {
  const tooltipContainerRef = React.useRef(null)
  const [leftPosition, setLeftPosition] = useState('35%')

  useEffect(() => {
    if (tooltipContainerRef.current) {
      const position = getLeftPosition(tooltipContainerRef.current)
      setLeftPosition(position)
    }
  }, [])
  const getLeftPosition = (tooltipContainer) => {
    const windowWidth = window.innerWidth
    const threshold = (3 / 4) * windowWidth 

    if (tooltipContainer) {
      const containerOffset = tooltipContainer.getBoundingClientRect().left
      if (containerOffset > threshold) {
        return '85%'
      }
    }
    return '20%'
  }
  return (
    <StyledTooltipContainer ref={tooltipContainerRef} width={containerWidth}>
      {children}
      {title && (
        <StyledTooltipContent
          placement={placement}
          arrow={arrow}
          leftPosition={leftPosition}
        >
          {title}
        </StyledTooltipContent>
      )}
    </StyledTooltipContainer>
  )
}

export default MyTooltip